import { useEffect, useRef } from 'react';

/**
 * Стек шарів для клавіші Esc: закривається лише верхній шар (спливне меню → діалог → панель задачі).
 * Один глобальний обробник замість десятків конкурентних.
 */
type Entry = { id: number; handler: () => void };
const stack: Entry[] = [];
let seq = 0;
let installed = false;

function install() {
  if (installed || typeof document === 'undefined') return;
  installed = true;
  document.addEventListener(
    'keydown',
    (e) => {
      if (e.key !== 'Escape' || e.defaultPrevented || e.isComposing) return;
      const top = stack[stack.length - 1];
      if (!top) return;
      e.preventDefault();
      e.stopPropagation();
      top.handler();
    },
    true,
  );
}

export function useEscapeLayer(active: boolean, handler: () => void) {
  const ref = useRef(handler);
  ref.current = handler;
  useEffect(() => {
    if (!active) return;
    install();
    const entry: Entry = { id: ++seq, handler: () => ref.current() };
    stack.push(entry);
    return () => {
      const i = stack.findIndex((x) => x.id === entry.id);
      if (i >= 0) stack.splice(i, 1);
    };
  }, [active]);
}

export function hasOpenLayers(): boolean {
  return stack.length > 0;
}
